import { useTranslations } from 'next-intl';

import MapPin from '@/components/icons/MapPin';
import Container from '../../Container';

interface Props {
  place: string;
}

export default function Location(props: Props) {
  const t = useTranslations('bar');
  return (
    <Container>
      <div className="text-center">
        <div className="flex justify-center mb-1">
          <MapPin className=" text-primary mr-2" />
          <div className="text-xl text-greyscale-label">
            {t('detail.youAreHere')}
          </div>
        </div>
        <h1 className="mb-0 font-bold text-4xl text-greyscale-title">
          {props.place}
        </h1>
      </div>
    </Container>
  );
}
